import { EmailFormContainer } from './EmailForm'

export const SettingsForm = () => {
  return <EmailFormContainer />
}
export default SettingsForm
